
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import moment from 'moment';

export class GenWeatherEpisode {

    advisory: boolean;
    associatedEvents: number;
    categories: string[];
    category: string;
    compound: boolean;
    durationHours: number;
    end: moment.Moment;
    episodeId: string;
    profile: string;
    start: moment.Moment;
    warning: boolean;

    constructor();
    constructor( jsonObj: any );
    constructor( genWeatherEpisode: GenWeatherEpisode);

    constructor( input?: GenWeatherEpisode ) {
        if ( input && typeof input !== 'number' ) {
            this.advisory = input.advisory; // boolean [boolean]
            this.associatedEvents = input.associatedEvents; // int [number]
            this.categories = input.categories; // list [string]
            this.category = input.category; // string [string]
            this.compound = input.compound; // boolean [boolean]
            this.durationHours = input.durationHours; // float [number]
            if ( input.end && typeof input.end === 'string' ) {
                this.end = moment(input.end).utc();
            } else {
                this.end = input.end;
            }
            this.episodeId = input.episodeId; // string [string]
            this.profile = input.profile; // string [string]
            if ( input.start && typeof input.start === 'string' ) {
                this.start = moment(input.start).utc();
            } else {
                this.start = input.start;
            }
            this.warning = input.warning; // boolean [boolean]
       }
    }

    static jsonResponseToList(arr: any[]): GenWeatherEpisode[] {
        if (arr && arr.map) {
          return arr.map(a => new GenWeatherEpisode(a));
        } else {
          return [];
        }
    }
}

